
import LsValue from '@/entities/LsValue'

# names
export GongVolume     = 'gong volume'
export RestDoneVolume = 'rest done volume'
export Rounds         = 'rounds'
export RoundTime      = 'round time'
export RestTime       = 'rest time'

export class Property

  # name
  # value
  # min
  # max
  # step
  #
  # lsValue    # LsValue

  dec: -> @_change -1
  inc: -> @_change 1

  _change: (diff) ->
    @value = @value + diff
    @value = Math.max @min, @value
    @value = Math.min @max, @value
    @

  clone: ->
    new Property()
      .setName  @getName()
      .setValue @getValue()
      .setMin   @getMin()
      .setMax   @getMax()
      .setStep  @getStep()

  save: -> a(@lsValue).set @value

  load: ->
    value = a(@lsValue).get null
    if value != null then @value = value
    @

  setName: (@name) ->
    @lsValue = new LsValue "property_#{ @name }"
    @
  getName: -> @name

  setValue: (@value) -> @
  getValue: -> @value

  setMin: (@min) -> @
  getMin: -> @min

  setMax: (@max) -> @
  getMax: -> @max

  setStep: (@step) -> @
  getStep: -> @step
